import React, { useState } from 'react';
import { Box, Text, Image, Button, Grid } from '@chakra-ui/react';
import TrackInfo from './TrackInfo';
import { useNavigate } from 'react-router-dom';

const Tracks = ({ items, service, selectedStorefront }) => {
  const [selectedTrack, setSelectedTrack] = useState(null);
  const navigate = useNavigate();

  const handleTrackSelect = (track) => {
    setSelectedTrack(track);
  };

  const handleTrackCreated = () => {
    navigate('/dashboard/artist/tracks');
  };

  return (
    <Box my={5}>
      {items.map((track) => {
        // Determine track name and image based on the service
        const trackName =
          service === 'spotify'
            ? track.name
            : track.attributes?.name;

        const trackImage =
          service === 'spotify'
            ? track.album.images?.[0]?.url
            : track.attributes?.artwork
              ? `${track.attributes.artwork.url.slice(
                  0,
                  track.attributes.artwork.url.length - 14
                )}/${track.attributes.artwork.width}x${track.attributes.artwork.height}bb.jpg`
              : '';

        return (
          <Box
            key={track.id}
            p={4}                          // Use moderate padding so nothing touches edges
            bg="secondary.900"
            color="primary.100"
            borderRadius="md"
            boxShadow="base"
            mb={7}
            transition="background 0.2s ease"
            _hover={{ bg: 'secondary.700' }}
            maxW="600px"                   // Limit card width for a better look
            mx="auto"                      // Center the card horizontally
          >
            <Grid
              templateColumns={{ base: '1fr', md: 'auto 1fr auto' }}
              templateRows={{ base: 'auto auto auto', md: 'auto' }}
              gap={{ base: 2, md: 3 }}      // Reduce gap for a tighter layout
              alignItems="center"
            >
              {/* Track Image */}
              <Image
                gridColumn={{ base: '1', md: '1' }}
                gridRow={{ base: '1', md: 'auto' }}
                w="60px"
                h="60px"
                src={trackImage}
                alt={trackName}
                borderRadius="md"
                transition="transform 0.2s"
                _hover={{ transform: 'scale(1.05)' }}
              />

              {/* Track Name */}
              <Text
                gridColumn={{ base: '1', md: '2' }}
                gridRow={{ base: '2', md: 'auto' }}
                fontWeight="normal"
                fontSize="sm"
                whiteSpace="normal"       // Allow wrapping of long names
                wordBreak="break-word"    // Break long words if needed
              >
                {trackName}
              </Text>

              {/* Create Button */}
              <Button
                gridColumn={{ base: '1', md: '3' }}
                gridRow={{ base: '3', md: 'auto' }}
                variant="brand"
                onClick={() => handleTrackSelect(track)}
                alignSelf={{ base: 'flex-end', md: 'center' }}
              >
                Select
              </Button>
            </Grid>
          </Box>
        );
      })}

      {/* Modal for TrackInfo */}
      {selectedTrack && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bg="rgba(0, 0, 0, 0.5)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={999}
        >
          <Box p={4} bg="primary.900" borderRadius="md" maxW="lg" w="full">
            <TrackInfo
              track={selectedTrack}
              storefront={selectedStorefront}
              onClose={() => setSelectedTrack(null)}
              platform={service}
              onTrackCreated={handleTrackCreated}
            />
          </Box>
        </Box>
      )}
      {/*
      // If you want PaymentModal in the future, uncomment here:
      // {isPaymentModalOpen && paymentModalData && (
      //   <Elements stripe={stripePromise}>
      //     <PaymentModal
      //       isOpen={isPaymentModalOpen}
      //       onClose={() => setIsPaymentModalOpen(false)}
      //       onPaymentSuccess={() => setIsPaymentModalOpen(false)}
      //       trackDetails={paymentModalData}
      //     />
      //   </Elements>
      // )}
      */}
    </Box>
  );
};

export default Tracks;
